/**
 * Missing-item art:
 * - Logo 0 outline redrawn as SVG strokes (circle + Nike-like swoosh)
 * - Inside a 3D outlined box
 * - All strokes use the theme primary accent
 */
export const buildDefaultItemImage = (primary: string, isDark: boolean) => {
	const ink = primary || (isDark ? "#ef5350" : "#8b1010");
	const ground = isDark ? "#1c1f25" : "#f3f4f6";

	const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="160" height="220" viewBox="0 0 160 220" fill="none">
  <rect width="160" height="220" fill="${ground}"/>

  <!-- 3D outlined box (wireframe), accent -->
  <g fill="none" stroke="${ink}" stroke-width="1.75" stroke-linejoin="round" stroke-linecap="round">
    <path d="M34 82 L106 82 L106 172 L34 172 Z"/>
    <path d="M34 82 L56 56 L128 56 L106 82 Z"/>
    <path d="M106 82 L128 56 L128 146 L106 172 Z"/>
    <path d="M56 56 L56 146" opacity="0.5"/>
    <path d="M56 146 L34 172" opacity="0.5"/>
    <path d="M56 146 L128 146" opacity="0.5"/>
  </g>

  <!-- Logo 0 outline — ring + open swoosh -->
  <g
    transform="translate(70 122)"
    fill="none"
    stroke="${ink}"
    stroke-width="2.7"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="0" cy="2" r="28"/>
    <path d="
      M -40 -4
      C -28 -14, -14 -16, -2 -8
      C  8 -2,  18 4,  28 0
      C  34 -2, 38 2,  44 8
    "/>
    <path d="
      M -36 4
      C -22 14, -6 14,  8 4
      C  18 -2, 26 -4, 36 0
      C  40 2,  42 6,  46 10
    "/>
    <path d="
      M -14 12
      C  -2 22, 12 22, 20 10
    "/>
    <path d="M -40 -4 L -46 0"/>
    <path d="M  44  8 L  52 14"/>
    <path d="M  40  0 L  50 -6"/>
  </g>
</svg>`.trim();

	return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};
